import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const MenuButton = ({
  menuItem,
  setActiveMenuItem,
  activeMenuItem,
  setActiveParentMenuItem,
  activeParentMenuItem,
  isMobile,
}) => {
  const location = useLocation();
  const { pathname } = location;

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setActiveParentMenuItem(
      activeParentMenuItem === menuItem.id ? null : menuItem.id
    );
    setIsExpanded(activeParentMenuItem !== menuItem.id);
  };

  const subItemActive =
    menuItem.subItems &&
    menuItem.subItems.some((subItem) => subItem.path === pathname);

  const isActive =
    activeMenuItem === menuItem.id ||
    subItemActive ||
    pathname === menuItem.path;

  const activeState = isActive
    ? "bg-[#338CC7] text-white font-medium"
    : "font-normal";

  const buttonStyles = {
    desktop: {
      container: `border border-r-0 mt-5 py-5 hover:bg-[#338CC7] hover:text-white cursor-pointer ${activeState}`,
      link: `block w-full h-full pl-20 `,
      subItemContainer: `py-5 hover:bg-[#99D0F4] hover:text-white bg-[#EDEDED]`,
      subItemLink: `block w-full h-full pl-20`,
    },
    mobile: {
      container: `w-full border-t border-b py-5 pr-10 mt-5 ${activeState}`,
      link: "",
      subItemContainer: `list-none w-full py-5 pr-10 bg-[#EDEDED]`,
      subItemLink: "",
    },
  };

  useEffect(() => {
    if (subItemActive) {
      setActiveMenuItem(menuItem.id);
      setActiveParentMenuItem(menuItem.id);
      setIsExpanded(true);
    } else if (isActive) {
      setActiveMenuItem(menuItem.id);
    } else {
      setActiveMenuItem(null);
    }
  }, [
    pathname,
    menuItem,
    setActiveMenuItem,
    setActiveParentMenuItem,
    isActive,
    subItemActive,
  ]);

  const buttonStyle = isMobile ? "mobile" : "desktop";

  return (
    <div className="list-none w-[100%]">
      <div
        onClick={menuItem.subItems ? toggleExpanded : undefined}
        className={`${buttonStyles[buttonStyle].container} ${
          menuItem.subItems && isActive && "border-b-0"
        }`}
      >
        <Link to={menuItem.path} className={buttonStyles[buttonStyle].link}>
          {menuItem.label}
        </Link>
      </div>
      {menuItem.subItems && isExpanded && (
        <div>
          {menuItem.subItems.map((subItem) => (
            <div
              className={`${buttonStyles[buttonStyle].subItemContainer} ${
                pathname === subItem.path
                  ? "bg-[#99D0F4] text-white font-medium"
                  : "font-normal"
              }`}
              key={subItem.id}
            >
              <Link
                className={buttonStyles[buttonStyle].subItemLink}
                to={subItem.path}
              >
                {subItem.label}
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MenuButton;
